import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[mytcButtonLoadingContent]',
  standalone: true,
})
export class ButtonLoadingContentDirective {
  @HostBinding('style.visibility')
  protected visibility: 'visible' | 'hidden';

  show(): void {
    this.visibility = 'visible';
  }

  hide(): void {
    this.visibility = 'hidden';
  }
}
